/* AgriBasket wishlist page.
   Renders the saved handles from localStorage as cards. The grid is rebuilt from
   storage on every change, so a removal, a same-tab change or a change made in
   another tab cannot leave a duplicate or stale card behind. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ab-wishlist]');
  if (!root) return;

  var KEY = 'agribasket-wishlist';
  var CHANGE_EVENT = 'agribasket:wishlist-change';

  /* Strings come from the theme locale files via snippets/agribasket-js-i18n.liquid. */
  var I18N = (window.AgroBucketI18n && window.AgroBucketI18n.strings) || {};
  function tr(key, fallback, vars) {
    var out = typeof I18N[key] === 'string' && I18N[key] ? I18N[key] : fallback;
    if (out == null) out = '';
    if (vars) {
      out = String(out).replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
        return Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : match;
      });
    }
    return out;
  }
  var grid = root.querySelector('[data-ab-wishlist-grid]');
  var empty = root.querySelector('[data-ab-wishlist-empty]');
  var status = root.querySelector('[data-ab-wishlist-status]');
  var renderToken = 0;

  function get() {
    try {
      var value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value.filter(function (item) { return typeof item === 'string' && item.trim(); }) : [];
    } catch (error) {
      return [];
    }
  }

  function set(value) {
    try {
      localStorage.setItem(KEY, JSON.stringify(value));
    } catch (error) {
      /* Storage can be unavailable in private modes; the list still repaints. */
    }
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-IN', { style: 'currency', currency: currency || 'INR', maximumFractionDigits: 2 }).format(cents / 100);
    } catch (error) {
      return '\u20b9' + (cents / 100).toFixed(2);
    }
  }

  function countLabel(count) {
    return count === 1
      ? tr('wishlist.saved', '{{ count }} saved product', { count: count })
      : tr('wishlist.saved_plural', '{{ count }} saved products', { count: count });
  }

  function card(product, handle) {
    var article = document.createElement('article');
    article.className = 'ab-wishlist__card';

    var link = document.createElement('a');
    link.href = '/products/' + encodeURIComponent(handle);
    var image = document.createElement('img');
    image.src = product.featured_image || ((product.images || [])[0] || '');
    image.alt = product.title || 'Product';
    image.loading = 'lazy';
    image.width = 500;
    image.height = 500;
    link.appendChild(image);
    article.appendChild(link);

    var body = document.createElement('div');
    body.className = 'ab-wishlist__card-body';
    var title = document.createElement('h2');
    title.textContent = product.title || 'Product';
    body.appendChild(title);

    var price = document.createElement('div');
    price.className = 'ab-wishlist__price';
    price.textContent = money(Number(product.price || 0), product.currency);
    body.appendChild(price);

    var remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'ab-wishlist__remove';
    remove.textContent = tr('wishlist.remove', 'Remove from wishlist');
    remove.addEventListener('click', function () {
      var next = get().filter(function (item) { return item !== handle; });
      set(next);
      document.dispatchEvent(new CustomEvent(CHANGE_EVENT, {
        detail: { handle: handle, saved: next.slice(), active: false }
      }));
    });
    body.appendChild(remove);

    article.appendChild(body);
    return article;
  }

  /* Rebuilds the list from storage. Idempotent, so a repaint never appends a
     second copy of a card, and a slow fetch from an earlier pass is dropped. */
  function render() {
    var token = ++renderToken;
    var handles = get();
    grid.textContent = '';
    empty.hidden = handles.length > 0;

    if (!handles.length) {
      status.textContent = '';
      return;
    }

    status.textContent = (handles.length === 1
      ? tr('wishlist.loading', 'Loading {{ count }} saved product', { count: handles.length })
      : tr('wishlist.loading_plural', 'Loading {{ count }} saved products', { count: handles.length })) + '\u2026';
    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('unavailable');
          return response.json();
        })
        .then(function (product) { return { product: product, handle: handle }; })
        .catch(function () { return null; });
    })).then(function (items) {
      if (token !== renderToken) return;
      /* Storage may have moved on while these products were loading. */
      var current = get();
      var valid = items.filter(function (item) { return item && current.indexOf(item.handle) > -1; });
      valid.forEach(function (item) { grid.appendChild(card(item.product, item.handle)); });
      status.textContent = valid.length ? countLabel(valid.length) : '';
      empty.hidden = valid.length > 0;
    }).catch(function () {
      if (token !== renderToken) return;
      status.textContent = tr('wishlist.error', 'We could not load your saved products right now.');
    });
  }

  window.addEventListener('storage', function (event) {
    if (event.key === KEY) render();
  });
  document.addEventListener(CHANGE_EVENT, render);

  render();
})();
